// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir=ltr] .action-badge[data-v-20b1b8a2] {\n  margin-right: 10px;\n}\n[dir=rtl] .action-badge[data-v-20b1b8a2] {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
